import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ResponseStatus, IStatusMessage } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { FacilityAllocation } from '../store';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-facility',
    templateUrl: './facility.component.html',
    styleUrls: ['./facility.component.scss'],
    standalone: false
})
export class FacilityComponent implements OnInit {
    @Input() allocationType = 1;
    messages: {
        severity: 'warn';
        detail: 'Changing Allocation type affects all allocations';
    }[] = [];
    public get columnHeader(): string {
        let label;
        document.getElementsByName('rgAllocationType').forEach((rb: any) => {
            if (rb.checked) {
                const t = this.facilityAllocationTypes.find(
                    // tslint:disable-next-line:triple-equals
                    x => x.value == rb.value
                );
                label = t && t.label;
            }
        });
        return label;
    }
    @Input() facilityAllocationTypes: SelectItem[];
    @Input() items: FacilityAllocation[];
    @Input() showAllocationWarning: boolean;
    private _selectedError: IStatusMessage;
    @Input() public set selectedError(value: IStatusMessage) {
        this.log.verbose({
            type: 'FacilityComponent:selectedError:set',
            value
        });
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        this.log.verbose({
            type: 'FacilityComponent:selectedError',
            value,
            row
        });
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    @Output() SaveFacilityAllocation = new ReplaySubject<FacilityAllocation>(1);
    public editing: FacilityAllocation = {} as FacilityAllocation;
    cloned: { [i: number]: FacilityAllocation } = {};
    constructor(private log: LoggingService) {}

    ngOnInit() {}

    onRowEditInit(item: FacilityAllocation) {
        this.cloned[item.id] = { ...item };
        this.editing = item;
        this.log.verbose({
            type: 'FacilityComponent:onRowEditInit',
            item,
            clonedFacilityAllocations: this.cloned,
            editing: this.editing
        });
    }
    onRowEditSave(item: FacilityAllocation) {
        this.log.verbose({
            type: 'FacilityComponent:onRowEditSave',
            item,
            clonedFacilityAllocations: this.cloned
        });
        item.Status.StatusCode = ResponseStatus.Loading;
        item.Status.Message = 'Saving';
        item.Allocationtypeid = this.allocationType;
        this.SaveFacilityAllocation.next(item);
        delete this.cloned[item.id];
        delete this.editing;
    }
    onRowEditCancel(item: FacilityAllocation) {
        this.log.verbose({
            type: 'FacilityComponent:onRowEditCancel',
            r: item,
            clonedFacilityAllocations: this.cloned
        });

        const index = this.items.findIndex(x => x.id === item.id);
        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.id]);
        }
        this.items = [...this.items];

        delete this.cloned[item.id];
        delete this.editing;
    }
    onStatusClick(item: FacilityAllocation) {
        this.log.verbose({
            type: 'FacilityComponent:onStatusClick',
            item
        });
        this.ShowError.emit({ open: true, MsgEntityID: item.id });
    }
}
